module.exports = __webpack_public_path__ + "static/media/mic_mute.ecbfae1f.png";